export const LHIC_CONTENT = {
  title: 'Loksarang Hardas Incubation Center',
  modalImage: 'images/lhic/lhic-exterior-gates.jpg',
  modalImageAlt: 'Loksarang Hardas Incubation Center exterior entrance, LITU Nagpur',
  intro:
    'Laxminarayan Innovation Technological University (LITU) has been leveraging its historic legacy of technological prowess and academic excellence to shift from producing job-seekers to nurturing job-creators. Aligned with national vision of Atmanirbhar Bharat and Viksit Bharat 2047, the university by way of assistance and the generous donations from LIT Alumni Association, has launched the Loksarang Hardas Incubation Center to empower the next generation of chemical engineering and technology entrepreneurs.',
  highlights: [
    {
      label: 'Inaugurated at the Global Alumni Meet Renaissance 2023',
      text: 'by Chief Minister Shri Devendra Fadnavis, Higher Education Minister Shri Chandrakant Patil, and BoG Chairman Padmashree Prof. Dr. G.D. Yadav.',
    },
    {
      label: 'Alumni-Driven Success',
      text: 'Built through the tireless efforts and generous Tan-Man-Dhan contributions of the LITAA global network.',
    },
    {
      label: 'Strategic Focus',
      text: 'Targeting high-growth, low-capex sectors like food, oils, and packaging technology to solve real-world industry problems.',
    },
    {
      label: 'Global Hub',
      text: 'Featuring a state-of-the-art mini-auditorium to bridge the gap between global academia, local industries, and angel investors.',
    },
  ],
  closing:
    'Backed by government grants and robust industry collaborations, the center is more than a physical space, it is a high-trust matchmaking ecosystem designed to propel revolutionary ideas onto the global stage.',
};

export const LHIC_GALLERY = [
  {
    src: 'images/lhic/lhic-exterior-sign.jpg',
    alt: 'LHIC building exterior with Loksarang Hardas Incubation Centre signage',
    caption: 'LHIC exterior — Loksarang Hardas Incubation Centre',
  },
  {
    src: 'images/lhic/lhic-exterior-gates.jpg',
    alt: 'LHIC entrance with open decorative gates and walkway',
    caption: 'LHIC entrance — open gates and walkway',
  },
  {
    src: 'images/lhic/lhic-entrance.jpg',
    alt: 'LHIC main entrance with glass doors and molecular art display',
    caption: 'Main entrance — glass doors and molecular art display',
  },
  {
    src: 'images/lhic/lhic-gallery-wall.jpg',
    alt: 'LHIC entrepreneur inspiration gallery wall with founder posters',
    caption: 'Entrepreneur gallery wall — founder inspiration posters',
  },
  {
    src: 'images/lhic/lhic-workspace.jpg',
    alt: 'LHIC open workspace with desks and collaboration area',
    caption: 'Open workspace — desks and collaboration area',
  },
  {
    src: 'images/lhic/lhic-conference-room.jpg',
    alt: 'LHIC conference room with meeting table and display screen',
    caption: 'Conference room — meeting and presentation space',
  },
];
